import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaUserMd, FaPhoneAlt, FaMapMarkerAlt, FaHeartbeat } from "react-icons/fa";

const Appointment = () => {
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedDisease, setSelectedDisease] = useState("");

  const hyderabadAreas = [
    "Banjara Hills",
    "Jubilee Hills",
    "Madhapur",
    "Kukatpally",
    "Ameerpet",
    "Secunderabad",
    "Gachibowli",
    "Dilsukhnagar",
    "Hitech City",
    "Kondapur",
    "Banjara Hills Road No. 12",
    "Jubilee Hills Check Post",
  ];

  const diseases = [
    "General Surgery",
    "Urology",
    "ENT",
    "Cardiology",
    "Dermatology",
    "Orthopedics",
    "Neurology",
    "Pediatrics",
  ];

  return (
    <section
      style={{
        padding: "100px 0",
        background: "radial-gradient(circle at 50% 20%, #e7f2ff 0%, #ffffff 70%)",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* Background Overlay */}
      <div
        style={{
          position: "absolute",
          top: "-80px",
          left: "0",
          width: "100%",
          height: "300px",
          opacity: "0.2",
        }}
      ></div>

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <h2
            style={{
              fontSize: "3rem",
              fontWeight: "800",
              color: "#0b1c39",
              marginBottom: "10px",
              letterSpacing: "1px",
            }}
          >
            Book Your <span style={{ color: "#ffcb24" }}>Appointment</span>
          </h2>
          <p
            style={{
              fontSize: "1.1rem",
              color: "#555",
              maxWidth: "600px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            Connect with top specialists and start your journey towards better health.
          </p>
        </div>

        {/* Main Layout */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "stretch",
            gap: "50px",
          }}
        >
          {/* Left Features */}
          <div
            style={{
              flex: "1 1 45%",
              minWidth: "300px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {[
              {
                icon: <FaUserMd />,
                title: "Top Specialists",
                desc: "Consult certified and experienced doctors for every concern.",
              },
              {
                icon: <FaHeartbeat />,
                title: "Personalized Care",
                desc: "We focus on delivering a comfortable and compassionate experience.",
              },
              {
                icon: <FaMapMarkerAlt />,
                title: "Citywide Coverage",
                desc: "Access quality healthcare across Hyderabad’s prime locations.",
              },
            ].map((feature, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.03, y: -5 }}
                transition={{ duration: 0.3 }}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "20px",
                  marginBottom: "25px",
                  padding: "20px",
                  background: "#ffffff",
                  borderRadius: "20px",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
                  border: "1px solid rgba(9,187,175,0.15)",
                }}
              >
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    background: "#ffcb24",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.8rem",
                    color: "#0b1c39",
                  }}
                >
                  {feature.icon}
                </div>
                <div>
                  <h4
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "700",
                      color: "#0b1c39",
                      marginBottom: "8px",
                    }}
                  >
                    {feature.title}
                  </h4>
                  <p
                    style={{
                      fontSize: "1rem",
                      color: "#555",
                      lineHeight: "1.8",
                      margin: 0,
                    }}
                  >
                    {feature.desc}
                  </p>
                </div>
              </motion.div>
            ))}

            {/* Areas Badge */}
            <div
              style={{
                background: "#09bbaf",
                color: "#fff",
                padding: "25px",
                borderRadius: "20px",
                textAlign: "center",
                marginTop: "30px",
              }}
            >
              <h4
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  marginBottom: "15px",
                }}
              >
                🏙️ Available Across Hyderabad
              </h4>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                {hyderabadAreas.slice(0, 6).map((area, index) => (
                  <span
                    key={index}
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      padding: "8px 15px",
                      borderRadius: "25px",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      backdropFilter: "blur(10px)",
                    }}
                  >
                    {area}
                  </span>
                ))}
              </div>
              <p
                style={{
                  marginTop: "15px",
                  fontSize: "0.9rem",
                  color: "rgba(255,255,255,0.8)",
                  fontStyle: "italic",
                }}
              >
                +{hyderabadAreas.length - 6} more areas...
              </p>
            </div>
          </div>

          {/* Right Form */}
          <div
            style={{
              flex: "1 1 45%",
              minWidth: "300px",
              background: "#09bbaf",
              padding: "40px",
              borderRadius: "25px",
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
              color: "#fff",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginBottom: "30px",
                position: "relative",
                zIndex: 2,
              }}
            >
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  background: "#ffcb24",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 15px",
                  fontSize: "1.8rem",
                  color: "#0b1c39",
                }}
              >
                📅
              </div>
              <h3
                style={{
                  fontSize: "1.75rem",
                  fontWeight: "700",
                  color: "#fff",
                  marginBottom: "10px",
                }}
              >
                Schedule Your Consultation
              </h3>
              <p
                style={{
                  color: "rgba(255,255,255,0.85)",
                  fontSize: "1rem",
                  margin: 0,
                }}
              >
                Fill in your details — our team will connect you to the right doctor.
              </p>
            </div>

            <form style={{ position: "relative", zIndex: 2 }}>
              {[{ icon: <FaUserMd />, placeholder: "Full Name", type: "text" },
                { icon: <FaPhoneAlt />, placeholder: "Mobile Number", type: "tel" }
              ].map((field, i) => (
                <div key={i} style={{ position: "relative", marginBottom: "20px" }}>
                  <input
                    type={field.type}
                    placeholder={field.placeholder}
                    style={{
                      width: "100%",
                      padding: "15px 15px 15px 50px",
                      borderRadius: "12px",
                      border: "none",
                      outline: "none",
                      fontSize: "1rem",
                      color: "#333",
                      background: "rgba(255,255,255,0.95)",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                      transition: "all 0.3s ease",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      left: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "1.2rem",
                      color: "#09bbaf",
                    }}
                  >
                    {field.icon}
                  </span>
                </div>
              ))}

              {/* Select Fields */}
              <div style={{ marginBottom: "20px" }}>
                <select
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "15px",
                    borderRadius: "12px",
                    border: "none",
                    outline: "none",
                    fontSize: "1rem",
                    color: "#333",
                    background: "rgba(255,255,255,0.95)",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  }}
                >
                  <option value="">Select Area in Hyderabad</option>
                  {hyderabadAreas.map((area, i) => (
                    <option key={i} value={area}>{area}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: "25px" }}>
                <select
                  value={selectedDisease}
                  onChange={(e) => setSelectedDisease(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "15px",
                    borderRadius: "12px",
                    border: "none",
                    outline: "none",
                    fontSize: "1rem",
                    color: "#333",
                    background: "rgba(255,255,255,0.95)",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  }}
                >
                  <option value="">Select Medical Specialty</option>
                  {diseases.map((disease, i) => (
                    <option key={i} value={disease}>{disease}</option>
                  ))}
                </select>
              </div>

              {/* Submit */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
                type="submit"
                style={{
                  background: "#ffcb24",
                  color: "#0b1c39",
                  padding: "16px",
                  borderRadius: "12px",
                  fontWeight: "700",
                  width: "100%",
                  fontSize: "1.1rem",
                  border: "none",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 8px 25px rgba(255,203,36,0.3)",
                }}
              >
                Book Free Appointment
              </motion.button>
            </form>

            {/* Footer Note */}
            <div style={{ textAlign: "center", marginTop: "25px" }}>
              <p
                style={{
                  color: "rgba(255,255,255,0.8)",
                  fontSize: "0.9rem",
                  margin: 0,
                }}
              >
                🔒 Your information is secure and confidential
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Appointment;
